import React from 'react';
import { Link } from 'react-router-dom';

// Fußzeile der Anmelde- und Rechtsseiten (wie PersoNYzer Fusszeile.js).
export const Fusszeile = () => (
  <footer className="mt-12 px-5 py-6 sm:px-6" style={{ borderTop: '1px solid rgba(214,221,227,.6)' }} data-testid="fusszeile">
    <div className="mx-auto flex max-w-[360px] flex-col items-center gap-2 text-center text-sm text-[#4b5768] sm:flex-row sm:justify-between sm:text-left">
      <span data-testid="fusszeile-copyright">© {new Date().getFullYear()} Das Relationship</span>
      <nav className="flex items-center gap-1.5" aria-label="Rechtliches">
        <Link to="/datenschutz" className="hover:text-[#1d4ed8] hover:underline" data-testid="fusszeile-datenschutz">Datenschutz</Link>
        <span aria-hidden="true">·</span>
        <Link to="/impressum" className="hover:text-[#1d4ed8] hover:underline" data-testid="fusszeile-impressum">Impressum</Link>
      </nav>
    </div>
  </footer>
);

export default Fusszeile;
